module.exports = {
  messages: {
    CN: {
      'serchKeyword.productNum': '商品数量',
      'serchKeyword.title': '关键字',
      'serchKeyword.font': '关键字',
      'serchKeyword.pls': '请输入关键字',
      'serchKeyword.basicontent': '基本信息',
      'serchKeyword.keywordProduct': '关键字商品',
      "serchKeyword.firstlineprompt": "1.第一列必须是商品编号",
      "serchKeyword.secondlineprompt": "2.从第二行数据开始导入",
      "serchKeyword.totalProduct": "共{totalPro}个商品，",
      "serchKeyword.alreadySelect": "已选{select}个",
      "serchKeyword.invalid": "下架",
      "serchKeyword.normal": "上架"
    },
    JP: {
      'serchKeyword.productNum': '商品数量',
      'serchKeyword.title': 'キーワード',
      'serchKeyword.font': 'キーワードを入力してください',
      'serchKeyword.pls': '基本情報',
      'serchKeyword.basicontent': '基本信息',
      'serchKeyword.keywordProduct': 'キーワードに関連する商品',
      "serchKeyword.firstlineprompt": "1.第一列必须是商品编号",
      "serchKeyword.secondlineprompt": "2.从第二行数据开始导入",
      "serchKeyword.totalProduct": "合計{totalPro}件の商品，",
      "serchKeyword.alreadySelect": "選択済み{select}件",
      "serchKeyword.invalid": "販売停止",
      "serchKeyword.normal": "販売開始"
    }
  }
};